import { render, staticRenderFns } from "./multipleCards.vue?vue&type=template&id=088d4f4b&scoped=true"
import script from "./multipleCards.vue?vue&type=script&lang=js"
export * from "./multipleCards.vue?vue&type=script&lang=js"
import style0 from "./multipleCards.vue?vue&type=style&index=0&id=088d4f4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d4f4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088d4f4b')) {
      api.createRecord('088d4f4b', component.options)
    } else {
      api.reload('088d4f4b', component.options)
    }
    module.hot.accept("./multipleCards.vue?vue&type=template&id=088d4f4b&scoped=true", function () {
      api.rerender('088d4f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/appCard/components/multipleCards.vue"
export default component.exports